export const CONTROLLER_API_PREFIX = 'components/search/api';

export const APP_NAME = 'search';

export const GATED_MAX_ANONYMOUS_PAGES = 5;

export enum UNI_API_CONTROLLER {
  license = 'license',
  agreements = 'agreements',
  contributor = 'contributor',
  relatedTerms = 'related-terms',
  filters = 'filters',
  taxonomy = 'taxonomy',
  indexability = 'indexability',
  searchProfile = 'search-profile',
  previouslyLicensed = 'previously-licensed',
  editorialTiles = 'editorial-tiles',
}

export const QUERY_KEYS = {
  agreements: ['agreements'],
  relatedTerms: ['relatedTerms'],
  contributor: ['contributor'],
  filters: ['filters'],
  searchProfile: ['searchProfile'],
  previouslyLicensed: ['previouslyLicensed'],
};
